'use strict';

import { createJSWorkletsModule } from "./JSWorklets.js";
export const WorkletsModule = createJSWorkletsModule();
//# sourceMappingURL=workletsModuleInstance.web.js.map